/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line




  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();


/*
 * Media blocks carousel
 * ---------------------
 * Autoplay + hover arrows for the "Media blocks" section (data-media-carousel).
 * Lives here (not inline in the section) because the Shopify theme editor
 * re-renders sections with innerHTML, and inline <script> tags inserted that
 * way never execute. Re-initialises on shopify:section:load.
 */
(function () {
  var SELECTOR = '[data-media-carousel]';

  // Agrupa chamadas que leem o layout em um quadro de animação, para não
  // recalcular o layout a cada evento de resize/scroll.
  function porQuadro(fn) {
    var agendado = false;
    return function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; fn(); });
    };
  }


  function initCarousel(track) {
    if (!track || track.mediaCarouselReady) return;
    track.mediaCarouselReady = true;

    var scope = track.closest('.media-carousel') || track.parentElement;
    var prev = scope.querySelector('[data-media-prev]');
    var next = scope.querySelector('[data-media-next]');
    var delay = parseInt(track.getAttribute('data-autoplay'), 10) || 0;
    var timer = null;

    function scrollable() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function step() {
      var item = track.querySelector('.mosaic__item');
      return item ? item.getBoundingClientRect().width : track.clientWidth;
    }

    function go(dir) {
      if (!scrollable()) return;
      var max = track.scrollWidth - track.clientWidth;
      var target = track.scrollLeft + dir * step();
      if (dir > 0 && track.scrollLeft >= max - 4) target = 0;
      if (dir < 0 && track.scrollLeft <= 4) target = max;
      track.scrollTo({ left: target, behavior: 'smooth' });
    }

    function sync() {
      var show = scrollable();
      if (prev) prev.hidden = !show;
      if (next) next.hidden = !show;
    }

    function start() {
      if (!delay || timer) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () {
        if (scrollable()) go(1);
      }, delay);
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (prev) prev.addEventListener('click', function () { go(-1); stop(); start(); });
    if (next) next.addEventListener('click', function () { go(1); stop(); start(); });

    scope.addEventListener('mouseenter', stop);
    scope.addEventListener('mouseleave', start);
    track.addEventListener('touchstart', stop, { passive: true });
    var syncPorQuadro = porQuadro(sync);
    window.addEventListener('resize', syncPorQuadro, { passive: true });
    window.addEventListener('load', syncPorQuadro);

    // Item widths only settle once CSS/media have loaded, so re-check for a while.
    if (window.ResizeObserver) {
      new ResizeObserver(syncPorQuadro).observe(track);
    }
    var checks = 0;
    var poll = setInterval(function () {
      sync();
      if (++checks > 12) clearInterval(poll);
    }, 250);

    sync();
    start();
  }

  function initAll(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var tracks = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < tracks.length; i++) initCarousel(tracks[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor re-renders a section: wire up the new DOM.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();


/*
 * Media blocks — video behaviour
 * ------------------------------
 * - The video plays MUTED (autoplay-muted works in every browser, incl. the
 *   in-app browsers of Instagram/Chrome/Safari) and, when "play on scroll" is
 *   on, starts when it enters the screen and pauses when it leaves.
 * - Audio always starts OFF; the visitor turns it on with the sound button.
 *   Only one video has audio at a time, and the hidden device's video (a
 *   display:none <video> still plays audio) is paused, so there is no overlap.
 * - Circular sound + play/pause buttons, plus a hint tooltip shown for 5s.
 */
(function () {
  var HINT_MS = 5000;

  function allVideos() {
    return document.querySelectorAll('[data-media-video]');
  }

  // A display:none element has no offsetParent -> it is the off-device layer.
  function isVisible(el) {
    return !!(el.offsetParent || el.getClientRects().length);
  }

  function pauseHidden() {
    var holders = document.querySelectorAll('[data-media-video-holder]');
    for (var i = 0; i < holders.length; i++) {
      if (!isVisible(holders[i])) {
        var v = holders[i].querySelector('[data-media-video]');
        if (v) { v.muted = true; if (!v.paused) v.pause(); }
      }
    }
  }

  function muteOthers(current) {
    var vids = allVideos();
    for (var i = 0; i < vids.length; i++) {
      if (vids[i] !== current) vids[i].muted = true;
    }
  }

  function show(el) { if (el) el.style.display = ''; }
  function hide(el) { if (el) el.style.display = 'none'; }

  function initMediaVideo(holder) {
    if (!holder || holder.mediaVideoReady) return;
    holder.mediaVideoReady = true;

    var video = holder.querySelector('[data-media-video]');
    if (!video) return;

    var playBtn = holder.querySelector('[data-media-play]');
    var soundBtn = holder.querySelector('[data-media-sound]');
    var hint = holder.querySelector('[data-media-hint]');
    var playOnScroll = holder.hasAttribute('data-play-on-scroll');
    var hintTimer = null;
    var soundWanted = false; // becomes true once the visitor turns sound on

    var iconSoundOn = holder.querySelector('.mv-icon--sound-on');
    var iconSoundOff = holder.querySelector('.mv-icon--sound-off');
    var iconPlay = holder.querySelector('.mv-icon--play');
    var iconPause = holder.querySelector('.mv-icon--pause');

    function styleBtn(btn, active) {
      if (!btn) return;
      if (active) {
        btn.style.background = '#ffffff';
        btn.style.color = '#111111';
        btn.style.borderColor = '#ffffff';
      } else {
        btn.style.background = 'rgba(18,18,26,.5)';
        btn.style.color = '#ffffff';
        btn.style.borderColor = 'rgba(255,255,255,.28)';
      }
    }

    function syncIcons() {
      holder.classList.toggle('is-playing', !video.paused);
      holder.classList.toggle('is-paused', video.paused);
      holder.classList.toggle('is-muted', video.muted);
      if (video.muted) { show(iconSoundOff); hide(iconSoundOn); }
      else { show(iconSoundOn); hide(iconSoundOff); }
      if (video.paused) { show(iconPlay); hide(iconPause); }
      else { show(iconPause); hide(iconPlay); }
      // Sound button lights up (white/active) when audio is on; play/pause keeps
      // the glassy look and only swaps its icon.
      styleBtn(soundBtn, !video.muted);
    }

    video.addEventListener('play', syncIcons);
    video.addEventListener('pause', syncIcons);
    video.addEventListener('playing', syncIcons);
    video.addEventListener('volumechange', syncIcons);

    function dismissHint() {
      if (!hint) return;
      hint.style.opacity = '0';
      if (hintTimer) { clearTimeout(hintTimer); hintTimer = null; }
      setTimeout(function () { hide(hint); }, 400);
    }

    function startHintTimer() {
      if (!hint || hintTimer) return;
      hintTimer = setTimeout(dismissHint, HINT_MS);
    }

    function playMuted() {
      if (!isVisible(holder)) return;
      video.muted = video.muted || !hasSound();
      var p = video.play();
      if (p && p.catch) p.catch(function () {});
      startHintTimer();
    }

    // "has sound" = user already turned it on for this video
    function hasSound() { return !video.muted; }

    function playInView() {
      if (!isVisible(holder)) return;
      // Restore the visitor's sound choice when the video comes back into view.
      if (soundWanted) { video.muted = false; muteOthers(video); }
      var p = video.play();
      if (p && p.catch) p.catch(function () {
        // If unmuted playback is blocked for any reason, fall back to muted.
        video.muted = true;
        var p2 = video.play();
        if (p2 && p2.catch) p2.catch(function () {});
      });
      if (!soundWanted) startHintTimer();
    }

    if (playOnScroll && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.5) {
            playInView();
          } else if (!entry.isIntersecting) {
            video.pause();
          }
        });
      }, { threshold: [0, 0.5, 1] });
      io.observe(holder);
    } else if (isVisible(holder)) {
      startHintTimer();
    }

    // Sound button — the block may be wrapped in <a>, so block navigation.
    if (soundBtn) {
      soundBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        soundWanted = !video.muted;
        if (soundWanted) {
          muteOthers(video);
          if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        }
        dismissHint();
        syncIcons();
      });
    }

    // Play / pause button
    if (playBtn) {
      playBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused) { var p = video.play(); if (p && p.catch) p.catch(function () {}); }
        else { video.pause(); }
        syncIcons();
      });
    }

    syncIcons();
  }

  function initMediaVideos(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    var holders = root.querySelectorAll('[data-media-video-holder]');
    for (var i = 0; i < holders.length; i++) initMediaVideo(holders[i]);
    pauseHidden();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initMediaVideos(); });
  } else {
    initMediaVideos();
  }

  // Antes rodava a cada resize sem limite — no celular isso cai no meio da rolagem.
  var pauseHiddenPorQuadro = (function () {
    var agendado = false;
    return function () {
      if (agendado) return;
      agendado = true;
      requestAnimationFrame(function () { agendado = false; pauseHidden(); });
    };
  })();
  window.addEventListener('resize', pauseHiddenPorQuadro, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { initMediaVideos(e.target); });
})();
